import React, { useState } from 'react'
import './login.css'
import data from './../../assets/data.json'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Footer from '../../components/Footer'
import closedLockIcon from './../../assets/images/login/icons8-sperren-32.png'
import openLockIcon from './../../assets/images/login/icons8-entsperren-32.png'
import passwordGif from './../../assets/images/login/icons8-passwort.gif'
import { enqueueSnackbar } from 'notistack'
import useAuth from '../../hooks/useAuth'

export default function Login({ fetchData }) {
	const LOGIN_URL = data.backendInterface.LOGIN_URL

	const [searchParams, setSearchParams] = useSearchParams()
	const futureAdresse = searchParams.get('futureAdresse') || '/'

	const navigate = useNavigate()

	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [disabled, setDisabled] = useState(false)

	const [loginIcon, setLoginIcon] = useState(closedLockIcon)

	const [iconFilter, setIconFilter] = useState('none')
	const [iconRight, setIconRight] = useState('0px')
	const [iconLeft, setIconLeft] = useState('0px')

	const [showCouldntLogin, setShowCouldntLogin] = useState(false)
	const [showForgottenPassword, setShowForgottenPassword] = useState(false)
	const [showForgottenEmail, setShowForgottenEmail] = useState(false)

	const [token, login, logout] = useAuth()

	function onSubmit(e) {
		e.preventDefault()

		if (!email) {
			setShowForgottenEmail(true)
			return
		}

		if (!password) {
			setShowForgottenPassword(true)
			return
		}

		setDisabled(true)
		setLoginIcon(passwordGif)

		setTimeout(() => {
			login(email, password)
				.then((result) => {
					if (result) {
						succedLogin()
					} else {
						failedLogin()
					}
				})
				.catch((error) => {
					setDisabled(false)
					setLoginIcon(closedLockIcon)
				})
		}, 2000)
	}

	function succedLogin() {
		const timeout = 1500

		enqueueSnackbar(data.message.succLogin, { variant: 'info' })

		setLoginIcon(openLockIcon)
		paintLoginIconGreen()
		setShowCouldntLogin(false)
		setDisabled(true)

		window.setTimeout(async () => {
			await fetchData()
			navigate(futureAdresse)
		}, timeout)
	}

	function failedLogin() {
		setLoginIcon(closedLockIcon)
		paintLoginIconRed()
		setDisabled(true)
		setShowCouldntLogin(true)

		shakeLoginIcon()

		window.setTimeout(function () {
			paintLoginIconBlack()
			setDisabled(false)
			setLoginIcon(closedLockIcon)
		}, 1000)
	}

	function paintLoginIconGreen() {
		setIconFilter(
			'invert(67%) sepia(95%) saturate(365%) hue-rotate(30deg) brightness(104%) contrast(86%)'
		)
	}

	function paintLoginIconRed() {
		setIconFilter(
			'invert(10%) sepia(96%) saturate(6885%) hue-rotate(358deg) brightness(92%) contrast(122%)'
		)
	}

	function paintLoginIconBlack() {
		setIconFilter('none')
	}

	function shakeLoginIcon() {
		shakeLoginIconStep(0)
	}

	function shakeLoginIconStep(counter) {
		const shakeWidth = 3
		const timeout = 30
		const shakeTime = 1000
		const maximum = shakeTime / timeout

		window.setTimeout(function () {
			if (counter >= maximum) {
				setIconRight('0px')
				setIconLeft('0px')
				return
			}

			if (counter % 2 == 0) {
				setIconLeft(shakeWidth + 'px')
				setIconRight('0px')
			} else {
				setIconRight(shakeWidth + 'px')
				setIconLeft('0px')
			}

			counter++
			shakeLoginIconStep(counter)
		}, timeout)
	}

	return (
		<div id='page-container'>
			<div id='mainFrame'>
				<div id='loginField'>
					<h1>Login Terminal</h1>

					<form
						action={LOGIN_URL}
						method='post'
						id='loginForm'
						onSubmit={onSubmit}
						disabled={disabled}
					>
						<div className='loginFieldProperty'>
							<div> Email </div>
							<input
								disabled={disabled}
								type='text'
								name='email'
								className='loginFieldInput'
								id='inputEmail'
								value={email}
								onInput={(e) => {
									setEmail(e.target.value)
									setShowForgottenEmail(false)
								}}
							/>
							<span
								style={{ display: showForgottenEmail ? 'block' : 'none' }}
								className='forgottenField'
								id='forgottenEmail'
							>
								{' '}
								E-Mail eingeben{' '}
							</span>
							<br />
						</div>

						<div className='loginFieldProperty'>
							<div> Password </div>
							<input
								disabled={disabled}
								type='password'
								name='password'
								className='loginFieldInput'
								id='inputPassword'
								value={password}
								onInput={(e) => {
									setPassword(e.target.value)
									setShowForgottenPassword(false)
								}}
							/>
							<span
								style={{ display: showForgottenPassword ? 'block' : 'none' }}
								className='forgottenField'
								id='forgottenPassword'
							>
								{' '}
								Passwort eingeben{' '}
							</span>
							<br />
						</div>

						<div id='loginButtonContainer' style={{ display: 'inline' }}>
							<button id='loginButton' disabled={disabled}>
								Login
							</button>

							<div id='loginIconContainer'>
								<img
									style={{
										filter: iconFilter,
										right: iconRight,
										left: iconLeft,
									}}
									type='image/jpg'
									sizes='16x16'
									rel='icon'
									src={loginIcon}
									id='loginIcon'
								/>
							</div>
						</div>
					</form>

					<div
						style={{ display: showCouldntLogin ? 'block' : 'none' }}
						id='couldntLoginText'
					>
						{' '}
						Falsches Passwort oder Email{' '}
					</div>

					<div id='autoLogoutInfo'>
						Nach 30 Minuten Inaktivität werden Sie automatisch ausgeloggt
					</div>
				</div>
			</div>
			<Footer />
		</div>
	)
}
